// @flow
import PlainLink, { type PlainLinkProps } from './plain-link';


export default PlainLink;

type Props = PlainLinkProps;
export type { Props, PlainLinkProps };
